import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCamera = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M8.7 6H3V4h5.7v2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16.3 13.55a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0zm-2 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3 6.9v13.3h19V6.9H3zm17 2H5v9.3h15V8.9z",
			clipRule: "evenodd"
		})
	]
});
export default SvgCamera;
